export function wait(timeoutMs) {
  return new Promise(resolve => {
    setTimeout(resolve, timeoutMs);
  });
}



// WEBPACK FOOTER //
// ./src/helpers/async.js